import React from 'react'
import { getImageUrl } from '../../utils/cdnUtils'

type Props = {
  title: string
  iconUrl?: string | null
  drawLabel: string
}

/** Header block for a result section (wrap bgi-3 bdr-5 ...). Matches latte-result.html. */
const LotteryResultSectionHeader: React.FC<Props> = ({ title, iconUrl, drawLabel }) => (
  <div className="wrap bgi-3 bdr-5 px-1 mb-1 bx-sd animateMe" data-animation="fadeInUp">
    <div className="icon-f">
      <img src={getImageUrl(iconUrl || 'logo.png')} alt="" />
    </div>
    <h5 className="t-medium mx-2 c-yellow">{title}</h5>
    <div className="bgc-4 bdr-10 px-2 c-red wrap justify-content-center ms-auto">
      <small>{drawLabel}</small>
    </div>
  </div>
)

export default LotteryResultSectionHeader
